export const TableColumn = {
  ACTIONS: '_______actions',
  EXPAND_BUTTON: '_______expandButton',
};
